import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OnChange } from 'src/app/custom-decorators/ngOnchanges.Decorator';

/**
 * constant imports
 */
import { REACTION_TYPE } from 'src/app/constants/app.constants';
@Component({
  selector: 'app-user-reaction',
  templateUrl: './user-reaction.component.html',
  styleUrls: ['./user-reaction.component.scss']
})
export class UserReactionComponent implements OnInit {

  constructor() {
    // 
   }


  public isReactionBarDisabled = false;
  public emojiArray = [{location: 'assets/images/like-story.png', value: REACTION_TYPE.LIKE}, {location: 'assets/images/heart-story.png', value: REACTION_TYPE.LOVE},{location: 'assets/images/congo-story.png', value: REACTION_TYPE.CELEBRATE}, {location:'assets/images/guess-story.png', value: REACTION_TYPE.THINK} , {location: 'assets/images/heart-hand.png', value: REACTION_TYPE.SUPPORT}];

  public emojiUrl: string;
  public showAnimation: boolean;

  public emojiIndex: number;

  public startPosition: number;

  @OnChange<void>('onResetAnimation')
  @Input() resetAnimation;


  @Output() emitReaction:  EventEmitter<string> = new EventEmitter();


  public animateAgain = 0;

  /**
   * flag to restart animation
   */
  public animate = 0;

  /**
   * to close animation
   * @param value 
   */
  onResetAnimation(): void {
    this.endAnimation(true);
  }

  create(value: number) {
    this.emojiIndex = value;
    this.isReactionBarDisabled = true;
    this.animate = this.animate + 1;
    this.startPosition = value*48 + 6;
    this.emojiUrl = this.emojiArray[value].location;
    this.showAnimation = true;
    this.emitReaction.emit(this.emojiArray[value].value);
    this.animate = this.animate + 1;
  }  

  endAnimation(status): void {
    this.isReactionBarDisabled = false;
    this.showAnimation = false;
  }
  ngOnInit(): void {
    // no code
  }

}
